import { t } from 'i18next';
import { mapValues } from 'lodash';
import { Yup } from '../../services/common/validation';
import { validateVIN } from '../../services/common/validationUtils';

const SUPPORTED_FORMATS = ['application/pdf', 'image/jpeg', 'image/png'];

const popupActivationValidationSchemaShape = {
  vinNumber: validateVIN(),
  licensePlate: Yup.string()
    .required(() => t('dashboard:popup:mandatoryText'))
    .matches(/^[A-Za-z]{2}-[0-9]{3}-[A-Za-z]{2}$/i, () => t('dashboard:popup:invalidLicencePlateTitle')),
  // TODO: review these dates as mandatory text is not being displayed
  deliveryDate: Yup.string().required(() => t('dashboard:popup:mandatoryText')),
  firstRegistrationDate: Yup.string().required(() => t('dashboard:popup:mandatoryText')),
};

export const getSubPagePaymentValidationSchema = () =>
  Yup.lazy((obj) => {
    return Yup.object(
      mapValues(obj, (_, key) => {
        if (key.includes('stipulation-')) {
          return Yup.mixed()
            .test(
              'required',
              () => t('dashboard:popup:mandatoryText'),
              (value: any) => !!value.length
            )
            .test(
              'mimeType',
              () => t('dashboard:popup:wrongFormatErrorTitle'),
              (value: any) => {
                return !value.some((stipulationFile) => !SUPPORTED_FORMATS.includes(stipulationFile.mimeType));
              }
            );
        }
        return popupActivationValidationSchemaShape[key];
      })
    );
  });
